import styled from '@emotion/styled';
import React, { useEffect } from 'react';
import { Helmet } from 'react-helmet';

export const StyledWrapper = styled.div`
  background-color: ${({ theme }) => theme.semantic.BgDefault};
  width: 100vw;
  height: auto;
  min-height: 100vh;
  display: flex;
  padding: 82px 0 46px;

  @media (max-width: 768px) {
    padding: 56px ${({ theme }) => theme.semantic.SpaceLayoutS}px 46px;
  }
`;

type PageLayoutProps = {
  children: React.ReactNode | React.ReactNodeArray;
  title?: string;
  description?: string;
  testId?: string;
};
export const PageLayout = ({ children, title, description, testId }: PageLayoutProps) => {
  useEffect(() => {
    document.querySelector('h1')?.setAttribute('tabindex', '-1');
    document.querySelector('h1')?.focus();
  }, []);
  return (
    <StyledWrapper data-testid={testId}>
      <Helmet>
        {title && <title>{title} | MGM Resorts</title>}
        {description && <meta name='description' content={description} />}
      </Helmet>
      {children}
    </StyledWrapper>
  );
};

PageLayout.displayName = 'PageLayout';
